export const SET_NOTIFICATION_UNREAD_COUNT = "SET_NOTIFICATION_UNREAD_COUNT";

export interface SetNotificationUnreadCount {
  type: typeof SET_NOTIFICATION_UNREAD_COUNT;
  payload: {
    unreadCount: number;
  };
}

export type NotificationDispatchType = SetNotificationUnreadCount;
